// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://ezfbftkjrjbgvftmqoazabhkla.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-qczgnmx46jhrbczmzecau5ngfu",
    "aws_cognito_identity_pool_id": "us-east-2:b90ef82d-4768-42dd-88cb-d4eec789ad48",
    "aws_cognito_region": "us-east-2",
    "oauth": {},
    "aws_mobile_analytics_app_id": "50371d2b405a4e97bf1fba11fd4e8463",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
